import { Injectable } from '@angular/core';
import * as Parse from 'parse';
import {PARSE_APP_ID, PARSE_MASTER_KEY, PARSE_SERVER_URL, production} from "../util/constants";


@Injectable()
export class RodapeService {

  parseAppId = PARSE_APP_ID;
  serverURL = PARSE_SERVER_URL;
  masterKey = PARSE_MASTER_KEY;

  constructor() { }

  init() {
    if (!production) {
      Parse.CoreManager.set('REQUEST_HEADERS', {'x-parse-application-id': this.parseAppId});
      Parse.CoreManager.set('REQUEST_HEADERS', {'x-parse-master-key': this.masterKey});
    }
    Parse.initialize(this.parseAppId, this.masterKey);
    Parse.serverURL = this.serverURL;
  }

  async get() {
    this.init();
    const Rodape = Parse.Object.extend('rodape');
    const queryRodape = new Parse.Query(Rodape);
    queryRodape.include('imagens');
    const results = await queryRodape.find();
    const arrayFinal: Array<any> = [];
    if (results.length > 0) {
      for (let i = 0; i < results.length; i ++) {
        const rodape = JSON.parse(JSON.stringify(results[i]));
        const queryImagens = results[i].get('imagens').query();
        queryImagens.ascending('ordem');
        const imagens = await queryImagens.find();
        rodape.imagens = JSON.parse(JSON.stringify(imagens));
        arrayFinal.push(rodape);
      }
    }
    return JSON.parse(JSON.stringify(arrayFinal))[0];
  }

}



// WEBPACK FOOTER //
// ./src/app/services/rodape.service.ts